export function isUnknownArray(value: unknown): value is UnknownArray {
  return Array.isArray(value);
}
